module.exports = __webpack_public_path__ + "static/media/new-applications.2f4d45a8.svg";